import { useEffect, useState } from 'react';
import { onValue, ref } from 'firebase/database';
import { db } from '../config/firebase';

export const DEFAULT_ACADEMY_SETTINGS = {
  name: 'Brissbella Academy',
  shortName: 'Brissbella',
  registrationNumber: '',
  logoURL: '',
  contactEmail: 'hello@brissbella.lk',
  contactPhone: '',
  website: 'https://brissbella.lk',
  addressLine: '',
  tagline: 'Learning with purpose.',
  tvecRegistrations: {},
};

export const useAcademySettings = () => {
  const [data, setData] = useState(DEFAULT_ACADEMY_SETTINGS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const academyRef = ref(db, 'settings/academy');
    const unsub = onValue(
      academyRef,
      (snapshot) => {
        const value = snapshot.val() || {};
        setData({ ...DEFAULT_ACADEMY_SETTINGS, ...value });
        setLoading(false);
      },
      () => {
        setData(DEFAULT_ACADEMY_SETTINGS);
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  return { academy: data, loading };
};

export default useAcademySettings;
